//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";
import '@nuxeo/nuxeo-ui-elements/widgets/nuxeo-user-avatar.js';
import Graph from "./Graph";
import {insightService} from "@/insight-service";

export default {
  name: "MissionActivity",
  components: {
    Graph
  },

  props: {
    mission: {
      type: Object,
      value: undefined,
    },
    // Flag indicating whether the component is display for the profile page or else
    profile: {
      type: Boolean,
      default: false,
    }
  },

  watch: {
    missions(newVal){
      // watch for the missions to load before fetching activities
      if(newVal) {
        this.fetchActivities(true);
      }
    },
    all(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.fetchActivities(newVal);
      }
    }
  },

  mounted: function(){
    if(this.mission) {
      this.fetchActivities(true);
    }        
  },

  data: () => ({
    loading: true,
    activities: [],
    loadingItems:[
      {name:' ', reviews:' ', daybyday:' '},      
      {name:' ', reviews:' ', daybyday:' '},
    ],
    sortBy: 'reviews',
    sortDesc: false,
    all: true,
    fields: [
      {
        key: 'participants',
        label: 'Participants'
      },
      {
        key: "reviews",
        label: 'Done Reviews',
        sortable: true,
      },
      {
        key: 'level',
        label: 'Level',
        sortable: true,
      },
      {
        key: 'daybyday',
        label: 'Day by Day',
      },
    ],
    fieldsForMe: [
      {
        key: 'name',
        label: 'Name'
      },
      {
        key: "reviews",
        label: 'Done Reviews',
        sortable: true,
      },
      {
        key: 'daybyday',
        label: 'Day by Day',
      },
    ]
  }),

  computed: {
    ...mapGetters(["currentClient", "projectId", "missions"]),
  },

  methods: {
    annotationData(annotations) {
      // take the last four annotations of the last 7 weeks
      let map = annotations.map((annotation) => {
        if (insightService.isWithinLastWeek(annotation['key_as_string'])) {
          return annotation['doc_count'];
        }
      }).filter((value) => value !== undefined);
      return map;
    },
    annotationDates(annotations) {
      // take the last four dates of the last 7 weeks
      let map = annotations.map((annotation) => {
        let date = annotation.key;
        if (insightService.isWithinLastWeek(date)) {
          return new Date(date);
        }
      }).filter((value) => value !== undefined);
      return map;
    },
    buildActivity(payload, allParticipants, missionNames = {}) {
      if (!(payload.hits && payload.aggregations)) {
        console.error("Something wrong with the payload of mission metrics")
        return;
      }
      if (allParticipants) {
        return payload.aggregations.participants.buckets.map((bucket) => {
          return {
            'name': bucket.key,
            'reviews': bucket.doc_count,
            'level': 1,
            'daybyday': bucket.series.buckets,
          }
        });
      }

      if (payload.aggregations.missions) {
        return payload.aggregations.missions.buckets.map((bucket) => {
          return {
            'name': missionNames[bucket.key],
            'reviews': bucket.doc_count,
            'daybyday': bucket.series.buckets,
          }
        });
      } else if (payload.aggregations.annotation) {
        return payload.aggregations.annotation.buckets.map((bucket) => {
          return {
            'name': bucket.key,
            'reviews': bucket.doc_count,
            'daybyday': bucket.series.buckets,
          }
        });
      }
    },

    fetchActivities(all) {
      this.all = all;
      this.activities = this.loadingItems;
      if (!(this.mission || this.missions)) {
        return;
      }
      this.loading = true;
      this.showDialog = false;
      this.$refs.fetchMetrics.params = {};
      this.$refs.fetchMetrics.params.all = all;
      let activities;
      if (this.mission) {        
        this.$refs.fetchMetrics.params.missionId = this.mission.uid;
        this.$refs.fetchMetrics
            .get()
            .then(response => {
              if (response) {
                activities = this.buildActivity(response, all);
              }
            })
            .finally(()=>{            
              this.loading = false;                
              this.activities = activities ? activities : [];
            });
      } else if (this.missions) {
        const missionNames = {};
        this.missions.forEach((mission) => {
          missionNames[mission.uid] = mission.properties['dc:title'];
        });
        this.$refs.fetchMetrics
            .get()
            .then(response => {
              if (response) {
                activities = this.buildActivity(response, all, missionNames);                
              }
            })
            .finally(()=>{
              this.loading = false;
              this.activities = activities ? activities : [];
            });
      }
      else {
        this.loading = false;
      }
      
    },
  },
}
;
